import "./PilotTransitions.module.css";
import Header from "@/reusable_sections/Header";
import CessationTriggers from "./sections/CessationTriggers";
import ThePlanningWindow from "./sections/ThePlanningWindow";
import RightSeatProgram from "./sections/RightSeatProgram";
import Footer from "@/reusable_sections/Footer";
export default function PilotTransitionsPage() {
  return <div>
      <Header />
      <CessationTriggers />
      <ThePlanningWindow />
      <RightSeatProgram />
      <Footer />
    </div>;
}